<div class="cl-cake-img"
     #imageWrap
     [style.backgroundImage]="'url(' + (image | multiUrlImage: 'original' : '/assets/img/content/default-cake-image.jpg') + ')'">
  <img #imageRef
       [alt]="alt"
       [src]="(image | multiUrlImage: 'original' : '/assets/img/content/default-cake-image.jpg')">
</div>
